import React, { FC } from 'react'
import styled, { css } from 'styled-components'

import arrowIcon from '../../assets/images/chevron.svg'

interface Props {
  page: number
  totalPages: number
  onPageChange: (data: number) => void
}

export const Pagination: FC<Props> = ({ page, onPageChange, totalPages }: Props) => {
  const nextPage = () => page < totalPages && onPageChange(page + 1)
  const prevPage = () => page - 1 > 0 && onPageChange(page - 1)

  return (
    <Container>
      <Button disabled={page === 1} onClick={prevPage}>
        <Prev src={arrowIcon} alt="prevIcon" />
      </Button>
      <Text>
        {page}&nbsp;of&nbsp;{totalPages}
      </Text>
      <Button disabled={page === totalPages} onClick={nextPage}>
        <Next src={arrowIcon} alt="nextIcon" />
      </Button>
    </Container>
  )
}

const Button = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  width: 32px;
  height: 32px;
  background-color: none;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
  > img {
    width: 12px;
    height: 12px;
  }
`

const Text = styled.div`
  color: #b8b8cc;
  font-size: 13px;
  min-width: 20px;
  text-align: right;
`

const Next = styled.img``

const Prev = styled.img`
  transform: rotate(-180deg);
`

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  > :first-child {
    margin-right: 15px;
  }
  > :last-child {
    margin-left: 15px;
  }
`
